export const SERVICES_IN_SERP_FEATURE_FLAG = 'services_in_serp';
export const SWISH_GC_CHECKOUT_FEATURE_FLAG = 'swish_gc_checkout';
export const QLIRO_GC_CHECKOUT_FEATURE_FLAG = 'qliro_gc_checkout';
export const DEALS_FEATURE_FLAG = 'deals_smoke_test';
export const NEW_PLACE_TWEAKS_EXPERIMENT = 'new-place-page-tweaks';
export const MEGA_MENU_NAVIGATION_FEATURE_FLAG_PLACE_ONLY = 'megamenu_navigation_place_only';
export const CHECKOUT_REDESIGN_FEATURE_FLAG = 'checkout_redesign';
export const FINNISH_TRANSLATION_FEATURE_FLAG = 'finnish-translation';
export const NEAR_ME_FLAG = 'near-me-autoscaling';

// add here all the search flags that should be sent to the backend
export const SEARCH_FLAGS = [NEAR_ME_FLAG];
export const MEGA_MENU_NAVIGATON_EXCLUDING_PLACE = {
  name: 'megamenu-navigation-excl-place',
  defaultValue: { enabled: true },
};
export const WEB_TEST_FLAG = { name: 'web_test_flag', defaultValue: { newTestVariant: false } };
